import Parse from 'parse'
import moment from 'moment-timezone'
moment.tz.setDefault('America/Mexico_City');

class Service extends Parse.Object {
  constructor() {
    super('Service');
  }

  get categoryName () {
    return this.get('category')
  }

  get category () {
    return this.get('category')
  }

  get name () {
    return this.get('name')
  }

  get minDuration () {
    return this.get('minDuration')
  }

  get maxDuration () {
    return this.get('maxDuration')
  }

  get description () {
    return this.get('description')
  }

  get desc () {
    return this.get('desc')
  }

  get quantity () {
    return this.get('quantity')
  }

  get used () {
    return this.get('used')
  }

  get enabled () {
    return this.get('enabled')
  }

  get price () {
    return this.get('price')
  }

  

  //-- Pointers and relations

  get title () {
    return this.get('title')
  }

  get used () {
    return this.get('used')
  }

  get expiration () {
    return moment(this.get('expirationDate'))
  }

  toggleBlock() {
    this.set("enabled", !this.enabled)
    return this.save()
  }

  changePrice(price) {
    this.set("price", price)
    return this.save()
  }

  static getObject(id){
    return new Parse.Query(this)
      .include('category')  
      .get(id)
  }

  static load (limit = 500, skip = 0) {
    return new Parse.Query(this)
      .limit(limit)
      .skip(skip)
      .include('Category')
      .find()
  }

  static create(params){

    let promocode = new Promocode()
    promocode.set('title', params.name)
    promocode.set('description', params.description)
    promocode.set('discount', Number(params.discount))
    promocode.set('available', Number(params.available))
    promocode.set('expirationDate', params.expirationDate)
    promocode.set('reusable', params.reusable)
    promocode.set('firstOrderOnly', params.firstOrderOnly)
    promocode.set('used', 0)

    return promocode.save()
  }

  //--- Cloud Functions

  static sendPushnotification(title, descripcion, urlImagen) {
    let params = {
      title: title,
      message: descripcion, 
      urlImagen: urlImagen
    }

    return Parse.Cloud.run('adminSendPushNotification', params)
  }

  dump () {
    console.log(this)
  }
}

export default Service
